/** @jsxRuntime classic */
/** @jsx h */
import {
  AutocompleteComponents,
  AutocompletePlugin,
  getAlgoliaResults,
} from '@algolia/autocomplete-js';
import { SearchResponse } from '@algolia/client-search';
import { h } from 'preact';
import { useState } from 'preact/hooks';

import { Blurhash, StarIcon, FavoriteIcon } from '../components';
import { ALGOLIA_PRODUCTS_INDEX_NAME } from '../constants';
import { searchClient } from '../searchClient';
import { ProductHit } from '../types';
import { cx } from '../utils';
const includedCategories = ['skincare'];
export const skincaresPlugin: AutocompletePlugin<ProductHit, {}> = {
  getSources({ query }) {
    if (!query) {
      return [];
    }

    return [
      {
        sourceId: 'skincaresPlugin',
        getItems({ setContext }) {
          return getAlgoliaResults<ProductHit>({
            searchClient,
            queries: [
              {
                indexName: ALGOLIA_PRODUCTS_INDEX_NAME,
                query,
                params: {
                  hitsPerPage: 6,
                  // facetFilters: ['brand.slug:aesthetics-rx'], this gonna filter only arx products
                  facetFilters: [
                    includedCategories.map(cat => `product_cat.slug:${cat}`)
                  ],
                  // optionalFilters: [
                  //   'brand.slug:aesthetics-rx'
                  // ],
                  // optionalWords: ['Aesthetics Rx', 'add-on'],
                  // Use this if you want to penalize certain attributes
                  // numericFilters: [
                  //   'brand.slug.aesthetics-rx < 1',
                  //   'slug.add-on < 1'
                  // ]
                },
              },
            ],
            transformResponse({ hits, results }) {
           
              setContext({
                nbSkincares: (results[0] as SearchResponse<ProductHit>).nbHits,
              });

              return hits;
            },
          });
        },
        onSelect({ setIsOpen }) {
          setIsOpen(true);
        },
        templates: {
          header({ state, Fragment }) {
            return (
              <Fragment>
                <div className="aa-SourceHeaderTitle">
                  Skincare for {state.query}
                </div>
                <div className="aa-SourceHeaderLine" />
              </Fragment>
            );
          },
          item({ item, components }) {
            return <ProductItem hit={item} components={components} />;
          },
          footer({ state }) {
            return (
                <div style={{ textAlign: 'center' }}>
                  <a
                    href="/skincare-products/"
                    rel="noreferrer noopener"
                    className="aa-SeeAllLink"
                  >
                    See All Skincares ({state.context.nbSkincares})
                  </a>
                </div>
            );
          },
        },
      },
    ];
  },
};



function formatPrice(value: number, currency: string) {
  return value.toLocaleString('en-US', { style: 'currency', currency });
}

type ProductItemProps = {
  hit: ProductHit;
  components: AutocompleteComponents;
};

function ProductItem({ hit, components }: ProductItemProps) {
  const [loaded, setLoaded] = useState(false);
  const [favorite, setFavorite] = useState(false);
  // console.log(hit);
  return (
    <div className="aa-ItemContentBody">
        <a
          href={hit.url}
          // target="_blank"
          rel="noreferrer noopener"
          className="aa-ItemLink">
      <div>
        <img
          src={hit.thumbnail}
          alt={hit.name}
          width="50px"
          height="50px"
          className="aa-ItemPicture me-2"
          onLoad={() => setLoaded(true)}
        />
      </div>
      <strong dangerouslySetInnerHTML={{ __html: hit.title }}></strong>
      
      </a>

    </div>
  );
}
